/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  SettingsResponse
} from './data.schemas'




export const getSettings = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SettingsResponse>> => {
    
    return axios.default.get(
      `/api/segments/${encodeURIComponent(String(segmentationId))}/settings`,options
    );
  }


export const getGetSettingsQueryKey = (segmentationId: number,) => {
    return [`/api/segments/${segmentationId}/settings`] as const;
    }

    
export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = AxiosError<unknown>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = AxiosError<unknown>

export const useGetSettings = <TData = Awaited<ReturnType<typeof getSettings>>, TError = AxiosError<unknown>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSettingsQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



